var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('a-spin',{attrs:{"spinning":_vm.spinning}},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"img"}),_vm._v(" "),_c('div',[_c('Register',{on:{"goLogin":_vm.goLogin,"forget":_vm.forget,"backLogin":_vm.backLogin}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }